module.exports = __webpack_public_path__ + "static/the-examined-life-how-we-lose-and-find-ourselves-a03549681929abb769c848652ca50664.jpg";